var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8273 1.67967C21.5606 0.893008 20.8139 0.333008 19.9339 0.333008H5.26725C4.38725 0.333008 3.65392 0.893008 3.37392 1.67967L0.600586 9.66634V20.333C0.600586 21.0663 1.20059 21.6663 1.93392 21.6663H3.26725C4.00059 21.6663 4.60059 21.0663 4.60059 20.333V18.9997H20.6006V20.333C20.6006 21.0663 21.2006 21.6663 21.9339 21.6663H23.2673C24.0006 21.6663 24.6006 21.0663 24.6006 20.333V9.66634L21.8273 1.67967ZM5.26725 14.9997C4.16059 14.9997 3.26725 14.1063 3.26725 12.9997C3.26725 11.893 4.16059 10.9997 5.26725 10.9997C6.37392 10.9997 7.26725 11.893 7.26725 12.9997C7.26725 14.1063 6.37392 14.9997 5.26725 14.9997ZM19.9339 14.9997C18.8273 14.9997 17.9339 14.1063 17.9339 12.9997C17.9339 11.893 18.8273 10.9997 19.9339 10.9997C21.0406 10.9997 21.9339 11.893 21.9339 12.9997C21.9339 14.1063 21.0406 14.9997 19.9339 14.9997ZM3.26725 8.33301L5.26725 2.33301H19.9339L21.9339 8.33301H3.26725Z",
    fill: "#F2F2F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleIcon);
export default __webpack_public_path__ + "static/media/vehicle_icon.0984ccf52f9ead79a3db5557d599a386.svg";
export { ForwardRef as ReactComponent };